<template>

    <ErrorSummary :response-status="responseStatus" />

    <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <h1 class="mt-6 text-3xl font-bold tracking-tight text-center text-gray-900">What is your closest metro area?</h1>
        <h2 class="mt-2 text-lg text-center text-gray-600">Select your nearest location so we can show you relevant auditions, performances and classes.</h2>

    </div>

    <div
        class="max-w-5xl px-4 py-8 mx-auto mt-8 border shadow-sm bg-white rounded-3xl border-clay-500 sm:px-10">
        <div class="mb-6">
            <div class="space-y-1">
                <h2 class="max-w-2xl pt-6 font-bold text-clay-900">It looks like your nearest major metro area is <span class="text-clay-800">{{ defaultAssignedRegion.name }}</span>.</h2>
                <p class="max-w-2xl">Don't worry about including your exact location, just the select the closest city.</p> 
            </div>
        </div>

        <TerritoriesTab :territories="territories" v-model="defaultAssignedRegion" @onRegionSelected="onRegionSelected">
        </TerritoriesTab>

        <div class="py-3 mt-3 text-center">
            <button
                class="w-full inline-flex items-center justify-center px-4 py-[calc(theme(spacing.2)-1px)] rounded-full border border-transparent bg-electric-600 shadow-md whitespace-nowrap text-base font-medium text-white data-[disabled]:bg-clay-50 data-[hover]:bg-electric-500 data-[disabled]:text-clay-500"
                type="submit" @click.prevent="next">
                Next
            </button>
            <button
                class="justify-center hidden w-full px-4 py-2 mt-4 text-sm text-gray-600 underline hover:no-underline"
                @click.prevent.stop="skip">
                Skip
            </button>
        </div>
        <button class="justify-center w-full px-4 py-2 mt-4 text-sm text-gray-600 underline hover:no-underline"
            type="submit" @click.prevent="emit('onBack');">
            Back
        </button>
    </div>

    <NotificationSuccess :show="updateSuccessful" content="Your changes were successfully saved."
        title="Successfully saved!" />

</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineEmits, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetAllTerritories, GetProfileRegion, GetProfileRegionResponse,
    Region, UpdateProfileRegion
} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import TerritoriesTab from "../Territories/TerritoriesTab.vue";

const responseStatus = ref(null);

const updateSuccessful = ref(false);
const territories = ref(new Array<Region>());

const defaultAssignedRegion = ref(new Region());

const territoryQuery = ref('');

onMounted(async () => {
    await client.get<Array<Region>>(new GetAllTerritories())
        .then(res => {
            territories.value = res.sort((a:Region, b:Region) => a.name.localeCompare(b.name));
        });

    await client.get<GetProfileRegionResponse>(new GetProfileRegion())
        .then(res => {
            defaultAssignedRegion.value = res.closestRegionForUser
        });
});

const filteredTerritories = computed(() =>
    territoryQuery.value === ''
        ? territories.value
        : territories.value.filter((territory: Region) => {
                return territory.name.toLowerCase().includes(territoryQuery.value.toLowerCase())
            }
        )
)

const emit = defineEmits(['onNext', 'onBack']);

const next = async () => {
    updateSuccessful.value = false;

    await client.post(new UpdateProfileRegion({territoryId: defaultAssignedRegion.value.id}))
        .then(() => {
            emit('onNext');
        })
}

const skip = async () => emit('onNext');

const onRegionSelected = (territory: Region) => {
    defaultAssignedRegion.value = territory;
}


</script>
<style>

</style>